import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../styles/constants';
import { styled } from '@material-ui/styles';
import { Box } from '@mui/material';

export const useStyles = makeStyles(theme => ({
	card: {
		display: 'flex',
		position: 'relative',
		flexWrap: 'wrap',
		flexDirection: 'column',
		justifyContent: 'space-between',
		maxWidth: 440,
		minWidth: 120,
		height: '100%',
		overflow: 'hidden',
		border: `1px solid ${COLORS.BORDER}`,
		backgroundColor: 'rgb(252, 252, 253)',
		borderRadius: '12px'
	},
	cardBody: {
		padding: theme.spacing(3)
	},
	cardFooter: {
		borderTop: `1px solid ${COLORS.BORDER}`,
		paddingTop: theme.spacing(2),
		paddingRight: theme.spacing(3),
		paddingLeft: theme.spacing(3),
		'&:last-child': {
			paddingBottom: theme.spacing(2)
		}
	},
	cardMedia: {
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(2),
		opacity: props => (props.released ? 1 : 0.5)
	},
	cardActions: {
		justifyContent: 'space-between',
		padding: theme.spacing(0)
	},
	description: {
		marginTop: theme.spacing(1),
		height: 84,
		fontWeight: 400,
		overflowY: 'auto',
		scrollbarWidth: 'none',
		'&::-webkit-scrollbar': {
			display: 'none'
		}
	},
	pointer: {
		'&:hover': {
			cursor: props => (props.released ? 'pointer' : 'auto')
		},
		fontWeight: '700'
	},
	icons: {
		display: 'flex',
		gap: theme.spacing(1.5)
	}
}));

export const CustomBadge = styled(Box)(({ theme }) => ({
	borderRadius: '4px',
	position: 'absolute',
	margin: theme.spacing(1.25),
	paddingInline: theme.spacing(1),
	paddingTop: theme.spacing(0.5),
	paddingBottom: theme.spacing(0.5),
	height: theme.spacing(2.5)
}));
